import React, { useEffect, useState } from "react";
import { MdDashboard } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useLocation } from "react-router-dom";

export default function Route({
  name = "Route name",
  icon = <MdDashboard />,
  onClick = null,
  rotate = false,
  urlPath="",
  bgColor = "bg-[#303641]",
}) {
  const location = useLocation();
  const [path, setPath] = useState("");
  useEffect(() => {
    setPath(location.pathname.split("/")[2]);
  }, [location.pathname]);

  return (
    <div>
      <div
        className={`flex gap-4 hover:text-white hover:bg-[#464e5d] ${bgColor} items-center p-3 border-b-[0.1px] border-gray-600 cursor-pointer duration-150`}
        onClick={onClick}
      >
        <div className={`text-lg ${rotate?'text-white':'text-[#a4a7ae]'} ${urlPath===path?'text-white':'text-[#a4a7ae]'}`}>{icon}</div>
        <div className="flex justify-between items-center text-xs font-normal cursor-pointer w-full">
          <div className={`select-none ${rotate?'text-white':'text-[#a4a7ae]'} ${urlPath===path?'text-white':'text-[#a4a7ae]'}`}>{name}</div>
          <div className="text-right">
            <MdOutlineKeyboardArrowRight
              className={`text-white text-lg ${
                rotate ? "rotate-90" : "rotate-0"
              } duration-200`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
